module.exports = __webpack_public_path__ + "img/00-gift-2500.0ca1c2c7.png";